import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage'
import { getApp } from 'firebase/app'

// first, get a reference to the storage bucket for our app

export const uploadFile = async (refPath: string, file: Blob | Uint8Array | ArrayBuffer, type: 'png' | 'jpeg') => {
  const storage = getStorage(getApp())
  const storageRef = ref(storage, refPath)
  const snapshot = await uploadBytes(storageRef, file, { contentType: `image/${type}` })

  return await getDownloadURL(snapshot.ref)
}

export const downloadFile = () => {}
